export default "__VITE_ASSET__CpgGQXOT__"